enum NotificationEnum {
	PasswordChange = 0,
	Welcome = 1,
	ThreeDaysInactive = 2,
	PremiumAccessThreeDaysLeft = 3,
	TwentyDaysInactive = 4
}
export default NotificationEnum
